import { ExperienceDisplayType } from '@ketch-sdk/ketch-types'

export const experienceDisplayTypeLabels = {
  [ExperienceDisplayType.Banner]: 'Banner',
  [ExperienceDisplayType.Modal]: 'Modal',
  [ExperienceDisplayType.Preference]: 'Preference',
  [ExperienceDisplayType.ConsentGate]: 'Consent Gate',
}
